module.exports = __webpack_public_path__ + "static/img/2.47b761d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/2.png
// module id = TtQP
// module chunks = 0